module.exports = __webpack_public_path__ + "assets/img/noneSearch@2x.2aed1714.png";